import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ax = axios.create({ baseURL: process.env.REACT_APP_API_URL || '', withCredentials: true });

const COLORS = [
  '#C8FF00','#60a5fa','#f87171','#fbbf24','#4ade80',
  '#a78bfa','#f472b6','#34d399','#fb923c','#38bdf8',
];

const CATEGORIES = [
  { v:'interne',   l:'Interne',   color:'#60a5fa' },
  { v:'client',    l:'Client',    color:'#4ade80' },
  { v:'marketing', l:'Marketing', color:'#f472b6' },
  { v:'admin',     l:'Admin',     color:'#fbbf24' },
];

const PRIORITIES = [
  { v:'haute',   l:'Haute',   color:'#f87171' },
  { v:'normale', l:'Normale', color:'#888'    },
  { v:'basse',   l:'Basse',   color:'#555'    },
];

const STATUSES = [
  { v:'todo',       l:'À faire',    color:'#888'    },
  { v:'en_cours',   l:'En cours',   color:'#C8FF00' },
  { v:'termine',    l:'Terminé',    color:'#4ade80' },
];

const EMPTY = {
  title: '', description: '', category: 'interne',
  startDate: '', endDate: '', color: COLORS[0],
  priority: 'normale', status: 'todo',
};

function toYMD(d) { return d instanceof Date ? d.toISOString().slice(0,10) : (d||''); }
function parseYMD(s) { if (!s) return null; const [y,m,d] = s.split('-'); return new Date(+y, +m-1, +d); }
function addDays(d, n) { const r = new Date(d); r.setDate(r.getDate() + n); return r; }
function startOfWeek(d) { const r = new Date(d); r.setDate(r.getDate() - r.getDay()); return r; }
function startOfMonth(d) { return new Date(d.getFullYear(), d.getMonth(), 1); }
function endOfMonth(d) { return new Date(d.getFullYear(), d.getMonth()+1, 0); }
function sameDay(a, b) { return a && b && toYMD(a) === toYMD(b); }

function getWeeksForMonth(year, month) {
  const first = startOfMonth(new Date(year, month, 1));
  const last  = endOfMonth(new Date(year, month, 1));
  const weeks = [];
  let cur = startOfWeek(first);
  while (cur <= last) {
    weeks.push(Array.from({ length:7 }, (_,i) => addDays(cur, i)));
    cur = addDays(cur, 7);
  }
  return weeks;
}

const JOURS = ['Dim','Lun','Mar','Mer','Jeu','Ven','Sam'];
const MOIS  = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];

const cat = (v) => CATEGORIES.find(c=>c.v===v) || CATEGORIES[0];
const pri = (v) => PRIORITIES.find(p=>p.v===v) || PRIORITIES[1];
const sta = (v) => STATUSES.find(s=>s.v===v)   || STATUSES[0];

const s = {
  page:    { color:'#F0F0F0', minHeight:'100%' },
  header:  { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:28, flexWrap:'wrap', gap:12 },
  h1:      { fontSize:'1.4rem', fontWeight:800, color:'#EAEAEA', letterSpacing:'-0.02em', margin:0 },
  tabs:    { display:'flex', gap:4, background:'rgba(255,255,255,0.04)', borderRadius:10, padding:4 },
  btnPri:  { display:'inline-flex', alignItems:'center', gap:7, background:'#C8FF00', color:'#000', border:'none', padding:'9px 20px', borderRadius:8, fontWeight:800, fontSize:'0.82rem', cursor:'pointer' },
  btnGhost:{ display:'inline-flex', alignItems:'center', gap:7, background:'transparent', color:'#555', border:'1px solid rgba(255,255,255,0.08)', padding:'9px 18px', borderRadius:8, fontWeight:600, fontSize:'0.82rem', cursor:'pointer' },
  card:    { background:'#111', border:'1px solid rgba(255,255,255,0.07)', borderRadius:14, overflow:'hidden' },
  th:      { padding:'10px 14px', fontSize:'0.68rem', fontWeight:700, color:'#555', letterSpacing:'0.08em', textTransform:'uppercase', textAlign:'left', borderBottom:'1px solid rgba(255,255,255,0.05)', background:'#0e0e12' },
  td:      { padding:'12px 14px', borderBottom:'1px solid rgba(255,255,255,0.04)', verticalAlign:'middle' },
  inp:     { width:'100%', background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, padding:'10px 12px', color:'#EAEAEA', fontSize:'0.88rem', outline:'none', boxSizing:'border-box', fontFamily:'inherit' },
  lbl:     { display:'block', fontSize:'0.7rem', color:'#555', marginBottom:5, fontWeight:700, letterSpacing:'0.08em', textTransform:'uppercase' },
};

function Pill({ text, color, bg }) {
  return (
    <span style={{ display:'inline-flex', alignItems:'center', gap:5, padding:'3px 9px', borderRadius:100, fontSize:'0.68rem', fontWeight:700, color: color||'#888', background: bg||'rgba(255,255,255,0.06)', letterSpacing:'0.04em', textTransform:'uppercase', whiteSpace:'nowrap' }}>
      {text}
    </span>
  );
}

function TabBtn({ active, onClick, children }) {
  return (
    <button onClick={onClick} style={{ padding:'6px 16px', borderRadius:7, border:'none', background: active ? '#C8FF00' : 'transparent', color: active ? '#000' : '#555', fontWeight:700, fontSize:'0.8rem', cursor:'pointer', transition:'all 0.15s' }}>
      {children}
    </button>
  );
}

function IconBtn({ icon, onClick, danger }) {
  const [hov, setHov] = useState(false);
  return (
    <button onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:28, height:28, borderRadius:6, border:`1px solid ${danger?(hov?'rgba(248,113,113,0.5)':'rgba(248,113,113,0.2)'):(hov?'rgba(255,255,255,0.2)':'rgba(255,255,255,0.07)')}`, background:'transparent', color:danger?(hov?'#fca5a5':'#f87171'):(hov?'#EAEAEA':'#555'), cursor:'pointer', transition:'all 0.15s', flexShrink:0 }}>
      {icon}
    </button>
  );
}

function TaskModal({ task, onClose, onSave, saving }) {
  const [form, setForm] = useState(task || EMPTY);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', backdropFilter:'blur(8px)', zIndex:600, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }} onClick={onClose}>
      <div style={{ background:'#0e0e12', border:'1px solid rgba(255,255,255,0.08)', borderRadius:16, padding:32, width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <h3 style={{ margin:0, fontSize:'1.1rem', fontWeight:800, color:'#EAEAEA' }}>{task?.id ? 'Modifier la tâche' : 'Nouvelle tâche'}</h3>
          <button style={{ background:'none', border:'none', color:'#555', cursor:'pointer', fontSize:'1.5rem', lineHeight:1 }} onClick={onClose}>×</button>
        </div>

        <div style={{ marginBottom:14 }}>
          <label style={s.lbl}>Titre</label>
          <input style={s.inp} value={form.title} onChange={e=>set('title', e.target.value)} placeholder="Titre de la tâche..." />
        </div>

        <div style={{ marginBottom:14 }}>
          <label style={s.lbl}>Description</label>
          <textarea style={{ ...s.inp, minHeight:72, resize:'vertical' }} value={form.description} onChange={e=>set('description', e.target.value)} placeholder="Détails..." />
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:14 }}>
          <div>
            <label style={s.lbl}>Catégorie</label>
            <select style={{ ...s.inp, appearance:'none', cursor:'pointer' }} value={form.category} onChange={e=>set('category', e.target.value)}>
              {CATEGORIES.map(c=><option key={c.v} value={c.v} style={{background:'#111'}}>{c.l}</option>)}
            </select>
          </div>
          <div>
            <label style={s.lbl}>Priorité</label>
            <select style={{ ...s.inp, appearance:'none', cursor:'pointer' }} value={form.priority} onChange={e=>set('priority', e.target.value)}>
              {PRIORITIES.map(p=><option key={p.v} value={p.v} style={{background:'#111'}}>{p.l}</option>)}
            </select>
          </div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:14 }}>
          <div>
            <label style={s.lbl}>Date début</label>
            <input type="date" style={{ ...s.inp, colorScheme:'dark' }} value={form.startDate} onChange={e=>set('startDate', e.target.value)} />
          </div>
          <div>
            <label style={s.lbl}>Date fin</label>
            <input type="date" style={{ ...s.inp, colorScheme:'dark' }} value={form.endDate} onChange={e=>set('endDate', e.target.value)} />
          </div>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:14 }}>
          <div>
            <label style={s.lbl}>Statut</label>
            <select style={{ ...s.inp, appearance:'none', cursor:'pointer' }} value={form.status} onChange={e=>set('status', e.target.value)}>
              {STATUSES.map(st=><option key={st.v} value={st.v} style={{background:'#111'}}>{st.l}</option>)}
            </select>
          </div>
          <div>
            <label style={s.lbl}>Couleur calendrier</label>
            <div style={{ display:'flex', gap:7, flexWrap:'wrap', marginTop:4 }}>
              {COLORS.map(c=>(
                <button key={c} onClick={()=>set('color', c)}
                  style={{ width:24, height:24, borderRadius:'50%', background:c, border:`3px solid ${form.color===c?'#fff':'transparent'}`, cursor:'pointer', outline:'none', padding:0, transition:'border 0.12s' }} />
              ))}
            </div>
          </div>
        </div>

        <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:24, paddingTop:20, borderTop:'1px solid rgba(255,255,255,0.05)' }}>
          <button style={s.btnGhost} onClick={onClose}>Annuler</button>
          <button style={{ ...s.btnPri, opacity:saving?0.6:1 }} onClick={()=>onSave(form)} disabled={saving}>
            {saving ? 'En cours...' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
}

function ListView({ tasks, onEdit, onDelete, onStatusChange }) {
  const [filter, setFilter] = useState('all');

  const visible = filter === 'all' ? tasks : tasks.filter(t => t.status === filter || t.category === filter);
  const sorted  = [...visible].sort((a,b) => {
    const order = { haute:0, normale:1, basse:2 };
    return (order[a.priority]||1) - (order[b.priority]||1);
  });

  return (
    <div>
      <div style={{ display:'flex', gap:8, marginBottom:16, flexWrap:'wrap' }}>
        {[
          { v:'all',     l:'Toutes' },
          ...STATUSES.map(s=>({ v:s.v, l:s.l })),
          ...CATEGORIES.map(c=>({ v:c.v, l:c.l })),
        ].map(f=>(
          <button key={f.v} onClick={()=>setFilter(f.v)}
            style={{ padding:'5px 13px', borderRadius:20, border:`1px solid ${filter===f.v?'rgba(200,255,0,0.4)':'rgba(255,255,255,0.08)'}`, background:filter===f.v?'rgba(200,255,0,0.1)':'transparent', color:filter===f.v?'#C8FF00':'#666', fontSize:'0.75rem', fontWeight:700, cursor:'pointer' }}>
            {f.l}
          </button>
        ))}
      </div>

      <div style={s.card}>
        {sorted.length === 0 ? (
          <div style={{ padding:48, textAlign:'center', color:'#333', fontSize:'0.9rem' }}>Aucune tâche</div>
        ) : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr>
                <th style={s.th}>Tâche</th>
                <th style={s.th}>Catégorie</th>
                <th style={s.th}>Priorité</th>
                <th style={s.th}>Dates</th>
                <th style={s.th}>Statut</th>
                <th style={s.th}></th>
              </tr>
            </thead>
            <tbody>
              {sorted.map(t=>{
                const c = cat(t.category);
                const p = pri(t.priority);
                const st = sta(t.status);
                return (
                  <tr key={t.id} style={{ transition:'background 0.1s' }}
                    onMouseEnter={e=>e.currentTarget.style.background='rgba(255,255,255,0.02)'}
                    onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                    <td style={s.td}>
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <span style={{ width:10, height:10, borderRadius:'50%', background:t.color||'#C8FF00', flexShrink:0, display:'inline-block' }}/>
                        <div>
                          <div style={{ fontWeight:700, color:'#EAEAEA', fontSize:'0.88rem', textDecoration:t.status==='termine'?'line-through':'none', opacity:t.status==='termine'?0.5:1 }}>{t.title}</div>
                          {t.description && <div style={{ fontSize:'0.75rem', color:'#555', marginTop:2 }}>{t.description.slice(0,60)}{t.description.length>60?'…':''}</div>}
                        </div>
                      </div>
                    </td>
                    <td style={s.td}><Pill text={c.l} color={c.color} /></td>
                    <td style={s.td}><Pill text={p.l} color={p.color} /></td>
                    <td style={s.td}>
                      <div style={{ fontSize:'0.78rem', color:'#666', whiteSpace:'nowrap' }}>
                        {t.startDate && <span>{t.startDate}</span>}
                        {t.startDate && t.endDate && <span style={{ color:'#333' }}> → </span>}
                        {t.endDate && <span>{t.endDate}</span>}
                      </div>
                    </td>
                    <td style={s.td}>
                      <select value={t.status} onChange={e=>onStatusChange(t.id, e.target.value)}
                        style={{ background:'transparent', border:'none', color:st.color, fontWeight:700, fontSize:'0.8rem', cursor:'pointer', outline:'none', fontFamily:'inherit', padding:0 }}>
                        {STATUSES.map(st2=><option key={st2.v} value={st2.v} style={{background:'#111', color:st2.color}}>{st2.l}</option>)}
                      </select>
                    </td>
                    <td style={{ ...s.td, textAlign:'right' }}>
                      <div style={{ display:'flex', gap:6, justifyContent:'flex-end' }}>
                        <IconBtn icon={<svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>} onClick={()=>onEdit(t)} />
                        <IconBtn danger icon={<svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>} onClick={()=>onDelete(t)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function CalendarView({ tasks, onEdit, onNew }) {
  const today = new Date();
  const [year,  setYear]  = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());

  const weeks = getWeeksForMonth(year, month);
  const firstDay = startOfMonth(new Date(year, month, 1));
  const lastDay  = endOfMonth(new Date(year, month, 1));

  const tasksByWeek = weeks.map(week => {
    const weekStart = week[0];
    const weekEnd   = week[6];
    return tasks.filter(t => {
      const ts = parseYMD(t.startDate);
      const te = parseYMD(t.endDate || t.startDate);
      if (!ts) return false;
      return ts <= weekEnd && te >= weekStart;
    });
  });

  const prevMonth = () => { if (month === 0) { setYear(y=>y-1); setMonth(11); } else setMonth(m=>m-1); };
  const nextMonth = () => { if (month === 11) { setYear(y=>y+1); setMonth(0); } else setMonth(m=>m+1); };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
        <button onClick={prevMonth} style={{ ...s.btnGhost, padding:'7px 12px' }}>‹</button>
        <span style={{ fontWeight:800, fontSize:'1.05rem', color:'#EAEAEA', minWidth:180, textAlign:'center' }}>{MOIS[month]} {year}</span>
        <button onClick={nextMonth} style={{ ...s.btnGhost, padding:'7px 12px' }}>›</button>
        <button onClick={()=>{ setYear(today.getFullYear()); setMonth(today.getMonth()); }}
          style={{ ...s.btnGhost, fontSize:'0.75rem', padding:'6px 12px', marginLeft:8 }}>Aujourd'hui</button>
      </div>

      <div style={{ ...s.card, overflow:'visible' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(7, 1fr)', borderBottom:'1px solid rgba(255,255,255,0.05)' }}>
          {JOURS.map(j=>(
            <div key={j} style={{ padding:'8px 6px', textAlign:'center', fontSize:'0.68rem', fontWeight:700, color:'#555', letterSpacing:'0.08em', textTransform:'uppercase' }}>{j}</div>
          ))}
        </div>

        {weeks.map((week, wi) => (
          <div key={wi} style={{ position:'relative', minHeight:96, borderBottom: wi<weeks.length-1?'1px solid rgba(255,255,255,0.04)':'none' }}>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(7, 1fr)', height:'100%' }}>
              {week.map((day, di) => {
                const isToday    = sameDay(day, today);
                const inMonth    = day >= firstDay && day <= lastDay;
                const isWeekend  = di === 0 || di === 6;
                return (
                  <div key={di} onClick={()=>onNew(toYMD(day))}
                    style={{ minHeight:96, padding:'6px 8px', cursor:'pointer', borderRight: di<6?'1px solid rgba(255,255,255,0.04)':'none', background: isToday?'rgba(200,255,0,0.03)':isWeekend?'rgba(255,255,255,0.01)':'transparent', transition:'background 0.1s', position:'relative' }}
                    onMouseEnter={e=>e.currentTarget.style.background= isToday?'rgba(200,255,0,0.06)':'rgba(255,255,255,0.03)'}
                    onMouseLeave={e=>e.currentTarget.style.background= isToday?'rgba(200,255,0,0.03)':isWeekend?'rgba(255,255,255,0.01)':'transparent'}>
                    <span style={{ fontSize:'0.75rem', fontWeight: isToday?800:500, color: isToday?'#C8FF00':inMonth?'#666':'#2a2a2a', display:'inline-flex', alignItems:'center', justifyContent:'center', width:22, height:22, borderRadius:'50%', background: isToday?'rgba(200,255,0,0.15)':'transparent' }}>
                      {day.getDate()}
                    </span>
                  </div>
                );
              })}
            </div>

            <div style={{ position:'absolute', top:30, left:0, right:0, pointerEvents:'none', padding:'0 4px', display:'flex', flexDirection:'column', gap:3 }}>
              {tasksByWeek[wi].map((t, ti) => {
                const weekStart = week[0];
                const weekEnd   = week[6];
                const ts  = parseYMD(t.startDate);
                const te  = parseYMD(t.endDate || t.startDate);
                const barStart = Math.max(0, ts < weekStart ? 0 : ts.getDay());
                const barEnd   = Math.min(6, te > weekEnd   ? 6 : te.getDay());
                const leftPct  = (barStart / 7) * 100;
                const widthPct = ((barEnd - barStart + 1) / 7) * 100;
                const roundL   = ts >= weekStart;
                const roundR   = te <= weekEnd;
                return (
                  <div key={t.id + '-' + wi} onClick={(e)=>{ e.stopPropagation(); onEdit(t); }}
                    title={t.title}
                    style={{
                      position:'absolute', top: ti * 22, height:18,
                      left:`${leftPct}%`, width:`${widthPct}%`,
                      background: t.color || '#C8FF00',
                      borderRadius:`${roundL?6:0}px ${roundR?6:0}px ${roundR?6:0}px ${roundL?6:0}px`,
                      opacity: t.status==='termine' ? 0.4 : 0.85,
                      display:'flex', alignItems:'center', paddingLeft:roundL?7:4,
                      overflow:'hidden', cursor:'pointer', pointerEvents:'all',
                      boxSizing:'border-box', zIndex: 10 + ti,
                      transition:'opacity 0.15s',
                    }}
                    onMouseEnter={e=>e.currentTarget.style.opacity='1'}
                    onMouseLeave={e=>e.currentTarget.style.opacity=t.status==='termine'?'0.4':'0.85'}>
                    <span style={{ fontSize:'0.65rem', fontWeight:800, color:'#000', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', letterSpacing:'0.01em' }}>
                      {roundL ? t.title : ''}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div style={{ display:'flex', flexWrap:'wrap', gap:12, marginTop:16 }}>
        {CATEGORIES.map(c=>(
          <span key={c.v} style={{ display:'inline-flex', alignItems:'center', gap:6, fontSize:'0.72rem', color:'#666' }}>
            <span style={{ width:10, height:10, borderRadius:3, background:c.color, display:'inline-block' }}/>
            {c.l}
          </span>
        ))}
        <span style={{ fontSize:'0.72rem', color:'#444', marginLeft:'auto' }}>Cliquez sur un jour pour créer · Cliquez sur une tâche pour modifier</span>
      </div>
    </div>
  );
}

export default function TasksSection() {
  const [tasks,   setTasks]   = useState([]);
  const [view,    setView]    = useState('liste');
  const [modal,   setModal]   = useState(null);
  const [saving,  setSaving]  = useState(false);
  const [delTarget, setDelTarget] = useState(null);

  const fetchTasks = useCallback(async () => {
    try {
      const { data } = await ax.get('/api/tasks');
      setTasks(Array.isArray(data) ? data : []);
    } catch {
      // serveur non disponible ou route inexistante
    }
  }, []);

  useEffect(() => { fetchTasks(); }, [fetchTasks]);

  const handleSave = useCallback(async (form) => {
    if (!form.title?.trim()) return;
    setSaving(true);
    try {
      if (form.id) {
        const { id, ...data } = form;
        await ax.put(`/api/tasks/${id}`, data);
      } else {
        await ax.post('/api/tasks', form);
      }
      setModal(null);
      fetchTasks();
    } finally {
      setSaving(false);
    }
  }, [fetchTasks]);

  const handleStatusChange = useCallback(async (id, status) => {
    await ax.put(`/api/tasks/${id}`, { status });
    fetchTasks();
  }, [fetchTasks]);

  const handleDelete = useCallback(async (t) => {
    await ax.delete(`/api/tasks/${t.id}`);
    setDelTarget(null);
    fetchTasks();
  }, [fetchTasks]);

  const openNew = useCallback((startDate='') => {
    setModal({ ...EMPTY, startDate, endDate: startDate });
  }, []);

  const stats = {
    total:    tasks.length,
    todo:     tasks.filter(t=>t.status==='todo').length,
    enCours:  tasks.filter(t=>t.status==='en_cours').length,
    termine:  tasks.filter(t=>t.status==='termine').length,
  };

  return (
    <div style={s.page}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>

      <div style={s.header}>
        <div>
          <h2 style={s.h1}>Tâches</h2>
          <p style={{ margin:'4px 0 0', color:'#555', fontSize:'0.82rem' }}>{stats.total} tâche{stats.total!==1?'s':''} · {stats.enCours} en cours · {stats.termine} terminée{stats.termine!==1?'s':''}</p>
        </div>
        <div style={{ display:'flex', gap:10, alignItems:'center', flexWrap:'wrap' }}>
          <div style={s.tabs}>
            <TabBtn active={view==='liste'}    onClick={()=>setView('liste')}>Liste</TabBtn>
            <TabBtn active={view==='calendrier'} onClick={()=>setView('calendrier')}>Calendrier</TabBtn>
          </div>
          <button style={s.btnPri} onClick={()=>openNew()}>
            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            Nouvelle tâche
          </button>
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(4, 1fr)', gap:12, marginBottom:24 }}>
        {[
          { label:'Total',         val:stats.total,   color:'#888'    },
          { label:'À faire',       val:stats.todo,    color:'#888'    },
          { label:'En cours',      val:stats.enCours, color:'#C8FF00' },
          { label:'Terminées',     val:stats.termine, color:'#4ade80' },
        ].map(card=>(
          <div key={card.label} style={{ background:'#111', border:'1px solid rgba(255,255,255,0.06)', borderRadius:12, padding:'16px 20px' }}>
            <div style={{ fontSize:'1.6rem', fontWeight:900, color:card.color, letterSpacing:'-0.03em', fontVariantNumeric:'tabular-nums' }}>{card.val}</div>
            <div style={{ fontSize:'0.72rem', color:'#444', fontWeight:700, marginTop:3, textTransform:'uppercase', letterSpacing:'0.06em' }}>{card.label}</div>
          </div>
        ))}
      </div>

      {view === 'liste' ? (
        <ListView
          tasks={tasks}
          onEdit={t=>setModal(t)}
          onDelete={t=>setDelTarget(t)}
          onStatusChange={handleStatusChange}
        />
      ) : (
        <CalendarView
          tasks={tasks}
          onEdit={t=>setModal(t)}
          onNew={openNew}
        />
      )}

      {modal && (
        <TaskModal
          task={modal}
          onClose={()=>setModal(null)}
          onSave={handleSave}
          saving={saving}
        />
      )}

      {delTarget && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', backdropFilter:'blur(8px)', zIndex:700, display:'flex', alignItems:'center', justifyContent:'center' }} onClick={()=>setDelTarget(null)}>
          <div style={{ background:'#0e0e12', border:'1px solid rgba(248,113,113,0.2)', borderRadius:14, padding:28, maxWidth:340, width:'90%', textAlign:'center' }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:'1.8rem', marginBottom:10 }}>⚠</div>
            <div style={{ color:'#EAEAEA', fontWeight:700, marginBottom:6 }}>Supprimer "{delTarget.title}" ?</div>
            <div style={{ color:'#444', fontSize:'0.82rem', marginBottom:22 }}>Action irréversible.</div>
            <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
              <button style={s.btnGhost} onClick={()=>setDelTarget(null)}>Annuler</button>
              <button style={{ ...s.btnPri, background:'#f87171', color:'#fff' }} onClick={()=>handleDelete(delTarget)}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
